/*
 * サブシステム名：マスタ管理
 * 機能名：車両マスタ一覧
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '../../components/DdCodeTextBox.vue'
import DdRadioButton from '@/components/DdRadioButton'
import DdTextBox from '../../components/DdTextBox.vue'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

export default {
  name: 'MstSharyoList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      sharyoCd: '',
      hacchusakiFlgKubun: '0',
      eigyoshoCd: '',
      hacchusakiCd: '',
      sharyoNo: '',
      jidoshaHyojiNm: ''
    },
    /*
    headersEigyoshoList: [
      { width: '60px', text: '営業所コード', value: 'eigyoshoCd' },
      { width: '90px', text: '営業所名', value: 'eigyoshoNm' }
    ],
    headersHacchusakiList: [
      { width: '60px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '90px', text: '取引先名', value: 'torihikisakiNm' }
    ]
    */
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchusakiList: header.mstTorihikisakiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdFooterButton,
    DdDataTable,
    DdCodeTextBox,
    DdRadioButton,
    DdTextBox
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      hacchusakiList: 'DDMasters/mstTorihikisaki',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredHacchusakiList () {
      // 発注先限定
      const target = filter.dateFormatter(new Date())
      return this.hacchusakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.hacchusakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredRows () {
      return this.rows.map((elem) => {
        if (elem.haishaYmd !== null) {
          elem.haishaYmdDisp = filter.dateFormatter(elem.haishaYmd)
        }
        if (elem.konyuYmd !== null) {
          elem.konyuYmdDisp = filter.dateFormatter(elem.konyuYmd)
        }
        if (elem.tekiyoStartYmd !== null) {
          elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        }
        if (elem.tekiyoEndYmd !== null) {
          elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        }
        if (elem.saidaisekisaiRyo !== null) {
          elem.saidaisekisaiRyoDisp = filter.numericFormatter(elem.saidaisekisaiRyo)
        }
        if (elem.nenpi !== null) {
          elem.nenpiDisp = filter.numericFormatter(elem.nenpi)
        }
        if (elem.konyuKakaku !== null) {
          elem.konyuKakakuDisp = filter.numericFormatter(elem.konyuKakaku)
        }
        if (elem.torokuTesuryo !== null) {
          elem.torokuTesuryoDisp = filter.numericFormatter(elem.torokuTesuryo)
        }
        if (elem.yoteiShiyoNensu !== null) {
          elem.yoteiShiyoNensuDisp = filter.numericFormatter(elem.yoteiShiyoNensu)
        }
        if (elem.jidoshaZeiKingaku !== null) {
          elem.jidoshaZeiKingakuDisp = filter.numericFormatter(elem.jidoshaZeiKingaku)
        }
        if (elem.juryoZei !== null) {
          elem.juryoZeiDisp = filter.numericFormatter(elem.juryoZei)
        }
        if (elem.shutokuZeiKingaku !== null) {
          elem.shutokuZeiKingakuDisp = filter.numericFormatter(elem.shutokuZeiKingaku)
        }
        if (elem.jibaisekiHokenKingaku !== null) {
          elem.jibaisekiHokenKingakuDisp = filter.numericFormatter(elem.jibaisekiHokenKingaku)
        }
        if (elem.sharyoHokenKingaku !== null) {
          elem.sharyoHokenKingakuDisp = filter.numericFormatter(elem.sharyoHokenKingaku)
        }
        if (elem.taijinHokenKingaku !== null) {
          elem.taijinHokenKingakuDisp = filter.numericFormatter(elem.taijinHokenKingaku)
        }
        if (elem.taibutsuHokenKingaku !== null) {
          elem.taibutsuHokenKingakuDisp = filter.numericFormatter(elem.taibutsuHokenKingaku)
        }
        if (elem.kamotsuHokenKingaku !== null) {
          elem.kamotsuHokenKingakuDisp = filter.numericFormatter(elem.kamotsuHokenKingaku)
        }
        if (elem.hyojiOrder !== null) {
          elem.hyojiOrderDisp = filter.numericFormatter(elem.hyojiOrder)
        }
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'msttorihikisaki'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstSharyoList.defineHeaderPromise')
            self.headers = [
              { text: '車両コード', value: 'sharyoCd' },
              { text: '所有区分', value: 'hacchusakiFlgKubun' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '車両表示名', value: 'jidoshaHyojiNm' },
              { text: '自動車登録番号', value: 'torokuNo' },
              { text: '車種種別', value: 'shashuSbtNm' },
              { text: '車両グループ種別１', value: 'sharyoGroupSbt1Nm' },
              { text: '車両グループ種別２', value: 'sharyoGroupSbt2Nm' },
              { text: '車両グループ種別３', value: 'sharyoGroupSbt3Nm' },
              { text: '車両グループ種別４', value: 'sharyoGroupSbt4Nm' },
              { text: '車両グループ種別５', value: 'sharyoGroupSbt5Nm' },
              { text: '運賃車種種別', value: 'unchinShashuSbtNm' },
              { text: '廃車年月日', value: 'haishaYmdDisp', align: 'center' },
              { text: '積載量', value: 'saidaisekisaiRyoDisp', align: 'end' },
              { text: '燃費', value: 'nenpiDisp', align: 'end' },
              { text: '購入年月日', value: 'konyuYmdDisp', align: 'center' },
              { text: '購入価格', value: 'konyuKakakuDisp', align: 'end' },
              { text: '登録手数料', value: 'torokuTesuryoDisp', align: 'end' },
              { text: '予定使用年数', value: 'yoteiShiyoNensuDisp', align: 'end' },
              { text: '自動車税金額', value: 'jidoshaZeiKingakuDisp', align: 'end' },
              { text: '重量税金額', value: 'juryoZeiDisp', align: 'end' },
              { text: '取得税金額', value: 'shutokuZeiKingakuDisp', align: 'end' },
              { text: '自賠責保険金額', value: 'jibaisekiHokenKingakuDisp', align: 'end' },
              { text: '車両保険金額', value: 'sharyoHokenKingakuDisp', align: 'end' },
              { text: '対人保険金額', value: 'taijinHokenKingakuDisp', align: 'end' },
              { text: '対物保険金額', value: 'taibutsuHokenKingakuDisp', align: 'end' },
              { text: '貨物保険金額', value: 'kamotsuHokenKingakuDisp', align: 'end' },
              { text: '適用開始年月日', value: 'tekiyoStartYmdDisp', align: 'center' },
              { text: '適用終了年月日', value: 'tekiyoEndYmdDisp', align: 'center' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              sharyoCd: '',
              hacchusakiFlgKubun: '0',
              eigyoshoCd: '',
              hacchusakiCd: '',
              sharyoNo: '',
              jidoshaHyojiNm: ''
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstSharyoList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstSharyoList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstSharyoList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstSharyoList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstSharyoList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMstSharyo/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            hacchusakiFlgKubun: self.conditions.hacchusakiFlgKubun
          }
        }
      }
      this.search(opt)
    },
    /*
    onSearchButtonClick: function (e) {
      this.Effects.loadStart()
      this.search().then(() => {
        console.log('this.search()', this.rows)
        this.Effects.loadComplete()
      })
    },
    search: function () {
      console.log('a', this.headers)
      return new Promise(resolve => {
        this.HttpClient
          .post('/api/v1/vwCMstSharyo/search', this.conditions)
          .then((data) => {
            this.rows = data.payload

            const cache = {
              rows: this.rows,
              conditions: this.conditions,
              searchText: this.searchText
            }
            this.saveToChache(cache)
              .then(() => {
                resolve()
              })
          })
      })
    },
    */
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.conditions = {
              sharyoCd: '',
              hacchusakiFlgKubun: '0',
              eigyoshoCd: '',
              hacchusakiCd: '',
              sharyoNo: '',
              jidoshaHyojiNm: ''
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCMstSharyo/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      return true
    }
  }
}
